<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner color="primary" [hidden]="!showSpinner"></fab-loading-spinner>
<!-- Header -->
<div id="header-container">
  <div>
    <h1 id="header-text">Process GM3PD Propulsion Snapshot</h1>
  </div>
</div>

<div class="top-section-container">
  <div class="propulsion-snapshot-container">
    <h2>Propulsion Snapshot</h2>
    <div class="button-container">
      <!--  button for loading the propulsion snapshot -->
      <div>
        <button mat-raised-button id="get-prop-snapshot-button"
                class="get-snapshot-button"
                color="primary"
                (click)="getPropulsionSnapshot()">
          Get Propulsion Snapshot
        </button>
      </div>
      <app-upload-button class="upload" [apiUrl]="excelService.excelSheetUrl"
                         (eventEmitter)="upload($event)"></app-upload-button>
    </div>
  </div>
  <div class="process-snapshot-container">
    <h2>Process Snapshot</h2>
    <div>
      <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedPortfolioType">
        <mat-radio-button [value]="businessPlan">{{ businessPlan }}</mat-radio-button>
        <mat-radio-button class="radio-options" [value]="tvp">{{ tvp }}</mat-radio-button>
      </mat-radio-group>
      <button mat-raised-button id="process-snapshot-button"
              class="process-snapshot-button"
              color="primary"
              (click)="processSnapshot()">Create Prop Port
      </button>
    </div>
  </div>
  <div class="unmatched-report-container">
    <h2>Unmatched Vehicle and Prop Snapshot Records Report</h2>
    <div id="button-container" class="button-container">
      <button mat-raised-button id="unmatched-report-button"
              class="unmatched-snapshot-report-button"
              color="primary"
              (click)="getUnmatchedVehAndPropReport()">
        Run Report
      </button>
    </div>
  </div>
</div>

<!-- Export button -->
<div class="export-button-container" *ngIf="showTable">
  <app-export-button id="export-button" class="no-custom-text"
                     [disabled]="tableDataExportRequest === undefined"
                     [excelExportService]="excelService"
                     [worksheetExportRequest]="tableDataExportRequest">
  </app-export-button>
</div>

<!-- Violation Tabs -->
<mat-tab-group mat-stretch-tabs="false" #violationTabGroup *ngIf="hasViolations"
               (selectedTabChange)="violationTabChange($event)"
               [(selectedIndex)]="violationTabIndex">
  <mat-tab label="Eng Rules Violation" id="duplicateEngDtlTab"
           *ngIf="violations.duplicateEngList.length > 0"></mat-tab>
  <mat-tab label="Trans Rules Violation" id="duplicateTranDtlTab"
           *ngIf="violations.duplicateTranList.length > 0"></mat-tab>
  <mat-tab label="Battery Rules Violation" id="duplicateBatTab"
           *ngIf="violations.duplicateBatList.length > 0"></mat-tab>
  <mat-tab label="Electr Rules Violation" id="duplicateElecTab"
           *ngIf="violations.duplicateElecList.length > 0"></mat-tab>
  <mat-tab label="PrimDr Rules Violation" id="duplicatePriDrvTab"
           *ngIf="violations.duplicatePriDrvList.length > 0"></mat-tab>
  <mat-tab label="SecDr Rules Violation" id="duplicateSecDrvTab"
           *ngIf="violations.duplicateSecDrvList.length > 0"></mat-tab>
  <mat-tab label="Date Violations" id="dateViolations" *ngIf="violations.dateViolations.length > 0"></mat-tab>
  <mat-tab label="Iteration Violations" id="iterationViolations"
           *ngIf="violations.iterationViolations.length > 0"></mat-tab>
  <mat-tab label="VFuel Violations" id="vFuelViolations"
           *ngIf="violations.vFuelViolations?.length > 0"></mat-tab>
</mat-tab-group>

<!--    Main Option Table-->
<div class="h-100" *ngIf="showTable">
  <div class="gfs-table">
    <ag-grid-angular
      style="height: 100%;"
      class="ag-theme-quartz"
      [rowData]="displayedData"
      [columnDefs]="propSnapshotColDef"
      [pagination]="true"
      [paginationPageSize]="pageSize"
      [paginationPageSizeSelector]="[20, 50, 100, 200, 2000]"
      [autoSizeStrategy]="autoSizeStrategy"
    />
  </div>
</div>
